/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class LinkedInIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      fill="currentcolor"
      width="24px"
      height="24px"
      viewBox="0 0 24 24" {...this.props}>
      <g id="linkedin">
        <g
          transform="translate(2.000000, 2.000000)"
          id="LinkedIn"
        >
          <path
            d="M20,11.7581142 L20,20 L15.9985495,20 L15.9985495,11.9857306 C15.9985495,11.5308104 15.9985495,9.07274857 13.5,9.07274857 C11.0070907,9.07274857 11.0070907,11.5556434 11.0070907,11.9857306 L11.0070907,20 L7,20 C7,20 7.05736333,6.63816984 7,5.28877012 L11.0070907,5.28877012 L11.0070907,7.66383802 C10.9984539,7.6790761 12.8351719,5.28877012 15.0970054,5.28877012 C17.8992642,5.28871829 20,7.34311263 20,11.7581142 Z M2.11808949,-1.77635684e-15 C0.837567341,-1.77635684e-15 0,0.877457203 0,2.03134332 C0,3.16008412 0.813335322,4.06417076 2.06840776,4.06417076 L2.09341098,4.06417076 C3.3987334,4.06417076 4.21052632,3.16025373 4.21052632,2.03134332 C4.18592899,0.877457203 3.3987334,-1.77635684e-15 2.11808949,-1.77635684e-15 Z M0,20 L4.21052632,20 L4.21052632,5.28877012 L0,5.28877012 L0,20 Z"
          />
        </g>
      </g>
    </svg>;
  }
}

const Icon = pure(LinkedInIcon);
Icon.displayName = 'LinkedInIcon';
export default Icon;
